// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page-error-404 {\n    background: #f5f5f5;\n}\n.error-box h1 {\n    color: #993333;\n}\n.error-box h5 {\n    color: #333;\n}\n", ""]);
// Exports
module.exports = exports;
